import React from 'react';
import { CloudOff } from 'lucide-react';

/**
 * Petite pastille posée sur la carte quand le fond ne se charge plus.
 *
 * Discrète (une ligne, au bas de la carte) et jamais rouge: la carte reste
 * utilisable, seul le fond manque. Les camions, les zones et le tracé ne
 * dépendent pas des tuiles.
 */
export default function AvisFond({ onReessayer, onPasserAuPlan = null }) {
  return (
    <div
      role="status"
      data-testid="avis-fond"
      className="pointer-events-auto absolute bottom-8 left-1/2 z-[500] flex max-w-[calc(100%-1.5rem)] -translate-x-1/2 flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-border bg-card/95 px-3 py-1 text-xs text-muted-foreground shadow-sm backdrop-blur-sm"
    >
      <CloudOff className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span className="font-medium text-foreground">Fond de carte indisponible</span>
      <button
        type="button"
        onClick={onReessayer}
        className="rounded-full px-1.5 py-0.5 font-semibold text-foreground underline underline-offset-2 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        Réessayer
      </button>
      {onPasserAuPlan && (
        <button
          type="button"
          onClick={onPasserAuPlan}
          className="rounded-full px-1.5 py-0.5 font-semibold text-foreground underline underline-offset-2 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          Passer au plan
        </button>
      )}
    </div>
  );
}
